/* eslint-disable */
import api from './../api';

export default async (email) => {
  ga('send', 'event', 'Button', 'click', 'Login: Forget Password');
  const rs = await api.post('login/recordarPassword', { email });
  if (rs.data.status === 200) {
    return { status: true };
  }
  return { status: false, message: rs.data.mensaje };
};



// WEBPACK FOOTER //
// ./src/app/services/auth/recovery.js